import { useState } from "react";
import { useEffect } from "react";
import Browser from "./Browser";
import Compatibility from "./Compatibility";
import Header from "./Header";
import Lerp from "./Lerp";
import Modes from "./Modes";
import Pricing from "./Pricing";
import { defAnims } from "./data";
import Program from "./Program";
import Simple from "./Simple";
import List from "./List";
import Light from "./Light";
import Footer from "./Footer"
import Overlay from "./Overlay";
import Feedback from "./Feedback";
const App = () => {

  const [scriptLoaded,setScriptLoaded] = useState(false)
  const [animations,setAnimations] = useState(defAnims)
  const [data,setData] = useState({})

  const [overlay,setOverlay] = useState(false)

  useEffect(()=>{
    const rand = Date.now()
    const url = 'https://csshero.org/animator_data/landing_contents.json?time='+rand
    fetch(url).then(k=>k.json()).then(k=>setData(k))
  },[])

  useEffect(()=>{
    if (!scriptLoaded){
      window.heroAnimator_saved_object = {}
      const script = document.createElement("script");
      script.src = "./heroanimator.min.js";
      script.async = true;
      script.onload = () => window.applyAllAnimations(animations)
      document.body.appendChild(script);
      setScriptLoaded(true)
      script.remove()
    }
  },[animations,scriptLoaded])

  const linkDemo = data?.demoLink ? data.demoLink : '#'
  const claim = data?.claim ? data.claim : 'WordPress Animator'
  const subClaim = data?.subClaim ? data.subClaim : ''
  const bodyClass = scriptLoaded ? 'opacity-100' : 'opacity-0'

  return <div className={'transition-all '+bodyClass}>
  <Header />
  {overlay ? <Overlay setOverlay={setOverlay} /> : []}
  <section className='dark bg-gradient-to-t from-violet-800 via-slate-900 to-slate-900 pb-10'>
    <div className='flex flex-col items-center'>
    
    <div className='max-w-prose text-center p-5 lg:py-20'>
      <h1>{claim}</h1>
      <p className='sub'>{subClaim}</p>
      <div className='buttonWrap'>
        <a className='button' href={linkDemo} target="_blank">Try demo</a>
        <a className='button primary' href='#buy'>Buy Now</a>
      </div>
    </div>
    <div className='container mx-auto p-10 lg:p-0'>
      <Browser>
       <div className='absolute inset-0 z-50 bg-slate-900 bg-opacity-50 opacity-0 hover:opacity-100 transition-all flex items-center justify-center'>
        <div className='button primary' onClick={()=>setOverlay(true)}>Video Tour</div>
       </div>
        <video autoPlay muted loop width="100%">
          <source src="https://csshero.org/wp-content/themes/dingo22/assets/vids/animator_video_perspective.mp4" type="video/mp4" />
        </video>

      </Browser>
    </div>
    </div>
  </section>
  <Modes />
  <Simple />
  <List />
  <Compatibility />
  <Lerp animations={animations} setAnimations={setAnimations} />
  <Light />
  <Program animations={animations} setAnimations={setAnimations} />
  <Feedback />
  <Pricing data={data} />
  <Footer />
  </div>
}

export default App;
